import { useState, useEffect, useRef } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useDispatch, useSelector } from 'react-redux';
import { galleryActions } from '../actions';
import { useNavigate } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';

const handleDragStart = (e) => e.preventDefault();

/**
 * El autoWidth de Alice mide el ancho de los slides al montar; con zoom/resize
 * el valor queda “pegado”. Forzamos remount con key al variar el viewport.
 */
function useAliceCarouselLayoutKey(enabled) {
    const [layoutKey, setLayoutKey] = useState(0)
    const timeoutRef = useRef(null)

    useEffect(() => {
        if (!enabled) return undefined

        const scheduleRefresh = () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            timeoutRef.current = setTimeout(() => {
                setLayoutKey((k) => k + 1)
            }, 120)
        }

        window.addEventListener('resize', scheduleRefresh)
        const vv = window.visualViewport
        if (vv) {
            vv.addEventListener('resize', scheduleRefresh)
        }

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            window.removeEventListener('resize', scheduleRefresh)
            if (vv) {
                vv.removeEventListener('resize', scheduleRefresh)
            }
        }
    }, [enabled])

    return layoutKey
}

function Carrousel({ isBannerBig, image, productsLanzamiento }) {
  const account = useSelector((state) => state.account);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const theme = useTheme()
  const sm = useMediaQuery(theme.breakpoints.only("sm"))
  const mobile = useMediaQuery(theme.breakpoints.down("md"))
  const carouselLayoutKey = useAliceCarouselLayoutKey(!!productsLanzamiento)

  const styles = {
    bannerCatalogo: {
      width: "50vw",
      height: "32.5vh",
      objectFit: "fill",
    },
    bannerCatalogoMobile: {
      width: "100vw",
      height: "25vh",
      objectFit: "cover",
    },
    blackDiv: {
      width: "100vw",
      lineHeight: "20px",
      padding: "10px",
      fontSize: "12px",
      backgroundColor: "black",
      color: "white",
      fontWeight: "0",
      fontFamily: 'BRFirma-Light,sans-serif',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer"
    },
    greenDiv: {
      width: "100vw",
      lineHeight: "25px",
      padding: "10px",
      fontSize: "25px",
      backgroundColor: "#9bcd65",
      color: "black",
      fontWeight: "0",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      letterSpacing: "0.3rem"
    },
  };


  const setLanzamientos = (categoria = "", promocion = "") => {
    dispatch(galleryActions.setSearchTerm(""))
    dispatch(galleryActions.setCategoria(categoria))
    dispatch(galleryActions.setRubro(""))
    dispatch(galleryActions.setSubRubro(""))
    dispatch(galleryActions.setPromocion(promocion))
    navigate("/catalogo")
  }

  const navigateToDistribuidores = () => {
    navigate("/register")
  }

  const catalogo = [
    <div style={styles.greenDiv} onDragStart={handleDragStart} role="presentation" onClick={() => navigateToDistribuidores()}>HAGASE DISTRIBUIDOR</div>,
    <div style={styles.greenDiv} onDragStart={handleDragStart} role="presentation" onClick={() => setLanzamientos("", "LANZAMIENTOS")}>VISITE NUESTROS NUEVOS LANZAMIENTOS</div>,
    <div style={styles.greenDiv} onDragStart={handleDragStart} role="presentation" onClick={() => setLanzamientos("", "LANZAMIENTOS")}>PORTAL EXCLUSIVO PARA LIBRERÍAS</div>,
  ];

  const logginCatalogo = [
    <div style={styles.blackDiv} onDragStart={handleDragStart} role="presentation" onClick={() => setLanzamientos("", "DESTACADOS")}>NUESTROS DESTACADOS</div>,
    <div style={styles.blackDiv} onDragStart={handleDragStart} role="presentation" onClick={() => setLanzamientos("", "LANZAMIENTOS")}>VISITE NUESTROS NUEVOS LANZAMIENTOS</div>,
  ]

  const homeCatalogo = [
    <img style={mobile ? (sm ? {} : styles.bannerCatalogoMobile) : styles.bannerCatalogo} src={image} onDragStart={handleDragStart} alt='catalogo-1' />,
    <img style={mobile ? (sm ? {} : styles.bannerCatalogoMobile) : styles.bannerCatalogo} src={image} onDragStart={handleDragStart} alt='catalogo-2' />
  ];
  const imageCondition =
    isBannerBig ? homeCatalogo : (account.isLoggedIn ? logginCatalogo : catalogo)

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
      <AliceCarousel
        key={productsLanzamiento ? `catalogo-${carouselLayoutKey}` : 'carousel-static'}
        mouseTracking
        autoPlayStrategy="none"
        autoPlayInterval={isBannerBig ? 6000 : 5000}
        animationDuration={isBannerBig ? 4500 : 4000}
        items={productsLanzamiento ? image : imageCondition}
        infinite
        autoPlay
        autoWidth
        disableButtonsControls
        disableDotsControls={!productsLanzamiento}
      />
    </Box>
  );
}

export default Carrousel;
